<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row>
          <b-form-group
            label="Nome"
            class="col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome"
            >
              <b-form-input
                v-model="form.nome"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-col cols="6">
            <div style="display: flex;">
              <div>
                <legend style="font-size: 14px;">
                  ID Omie
                </legend>
              </div>
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  title="Nesse campo deve ser feito vínculo dessa equipe com a Omie, selecionando qual departamento da Omie corresponde a esse cadastro!"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <v-select
              v-model="form.nomeDepartamentoOmie"
              :options="itens"
              :label="'descricao'"
              @open="carregarEquipesOmie"
              @input="selecionadaDepartamentoOmie"
            />
          </b-col>
        </b-row>

        <b-row class="mb-1">

          <b-col cols="2">
            <b-btn
              id="corEquipe"
              :style="`background-color:${form.cor} !important`"
              :variant="getVariante()"
              @click="mostrarPopover = true"
            >
              Cor da Equipe
            </b-btn>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox
              v-model="form.simplesNacional"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 0.7rem"
              @change="verificaEquipeSNExistente($event)"
            >
              Simples Nacional
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox
              v-model="form.participaRodizioEquipe"
              value="true"
              unchecked-value="false"
              style="margin-top: 0.7rem"
            >
              Participar do Rodízio da Equipe
            </b-form-checkbox>
          </b-col>
        </b-row>
      </template>
    </cadastro-base>

    <b-popover
      :id="'corEquipePopover'"
      ref="corEquipePopover"
      target="corEquipe"
      placement="auto"
      triggers="manual"
      :show.sync="mostrarPopover"
    >
      <div slot="title">
        <span
          class="text-center"
          style="vertical-align: sub"
        >Escolha a Cor da Equipe</span>

        <b-button
          variant="none"
          class="close"
          @click="mostrarPopover = false"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </div>

      <div class="tagcreate-color">
        <div
          v-for="cor in cores"
          :key="cor.id"
          :style="`background-color:${cor}`"
          :class="{'tagcreate-select': form.cor == cor, 'opcao-branca': cor === '#FFFFF'}"
          @click.prevent.stop="mudarCor(cor)"
        />

      </div>
    </b-popover>
  </div>
</template>

<style lang="scss">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}
.tagcreate-color {
  display: block;
  margin-bottom: 0.4rem;
  margin-top: 0.4rem;

  & > label {
    font-size: 0.9rem;
    display: block;
  }

  & > div {
    height: 40px;
    width: 45px;
    margin: 0.2rem;
    border-radius: 4px;
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  }

  & > .tagcreate-select {
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.507),
      0 6px 20px 0 rgba(0, 0, 0, 0.301);
    // opacity: 0.5;
  }
}

.opcao-branca{
  border: 1px solid #82868b !important;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import '@core/scss/vue/libs/vue-select.scss'
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comuns/equipe/shared/services/api'

export default {
  name: 'Equipe',
  components: {
    CadastroBase,
    ValidationProvider,
    vSelect,
    FontAwesomeIcon,
  },
  data() {
    return {
      faQuestionCircle,
      required,
      form: {
        id: 0,
        equipe: '',
        nivel: null,
        simplesNacional: false,
        participaRodizioEquipe: false,
        cor: 'none',
        idDepartamentoOmie: null,
        nomeDepartamentoOmie: null,
      },
      immutableForm: {},
      niveis: [
        { value: 'nivel1', text: 'NÍVEL 1 - até R$ 2.000,00' },
        { value: 'nivel2', text: 'NÍVEL 2 - até R$ 2.001,00 a R$ 5.000,00' },
        { value: 'nivel3', text: 'NÍVEL 3 - acima de R$ 5.000,00' },
      ],
      cores: ['#376996', '#D62839', '#5FAD56', '#FF6B35', '#F5B700', '#EF709D', '#6f2087', '#636363', '#FFFFF', '#000000', '#38bdf8', '#a3e635'],
      mostrarPopover: false,
      variante: '',
      sobrescreveSN: false,
      itens: [],
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getEquipe(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (this.state === 'novo') {
          api.createEquipe(this.form, this.sobrescreveSN)
            .then(() => {
              this.$router.go(-1)
              resolve('Equipe cadastrada com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateEquipe(this.form.id, this.form, this.sobrescreveSN)
            .then(() => {
              this.$router.go(-1)
              resolve('Equipe alterada com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
    mudarCor(cor) {
      this.form.cor = cor
    },
    getVariante() {
      return this.form.cor === 'none' ? 'outline-secondary' : ''
    },
    verificaEquipeSNExistente() {
      if (this.form.simplesNacional) {
        api.verificaEquipeSNExistente(this.form.id)
          .then(payload => {
            if (payload.data && this.form.simplesNacional) {
              this.$swal({
                title: 'Deseja marcar como Simples Nacional?',
                text: 'A ação irá sobrescrever a equipe já existente com essa configuração.',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                showCancelButton: true,
                focusConfirm: false,
                type: 'question',
                customClass: {
                  confirmButton: 'mr-1 w-25 btn-primary',
                  cancelButton: 'w-25 btn-danger',
                },
              })
                .then(result => {
                  this.sobrescreveSN = !!result.value
                  this.form.simplesNacional = result.value
                })
            }
          })
      } else {
        this.sobrescreveSN = false
      }
    },
    carregarEquipesOmie() {
      api.listarDepartamentosOmie()
        .then(payload => {
          this.itens = payload.data
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
    selecionadaDepartamentoOmie(value) {
      if (value) {
        this.$set(this.form, 'idDepartamentoOmie', value.codigo)
        this.$set(this.form, 'nomeDepartamentoOmie', value.descricao)
      } else {
        this.$set(this.form, 'idDepartamentoOmie', null)
        this.$set(this.form, 'nomeDepartamentoOmie', null)
      }
    },
  },
}
</script>
